exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".discount-without[data-v-cc08229e]{position:relative;font-size:12px;font-weight:400;margin-right:10px;color:#fa314a}.discount-without[data-v-cc08229e]:before{content:\"\";position:absolute;top:6px;width:100%;height:1px;background-color:#fa314a;transform:rotate(-10deg)}", ""]);

